import React, { createContext, useContext, useReducer } from 'react';

interface ChatState {
  sessions: any[];
  onlineUsers: string[];
  loading: boolean;
}

const initialState: ChatState = {
  sessions: [],
  onlineUsers: [],
  loading: false,
};

const ChatContext = createContext<{
  state: ChatState;
  sessions: any[];
  loading: boolean;
}>({
  state: initialState,
  sessions: [],
  loading: false,
});

function chatReducer(state: ChatState, action: any): ChatState {
  switch (action.type) {
    case 'SET_LOADING':
      return { ...state, loading: action.payload };
    case 'SET_SESSIONS':
      return { ...state, sessions: action.payload, loading: false };
    case 'ADD_ONLINE_USER':
      const newOnlineUsers = Array.from(new Set([...state.onlineUsers, action.payload]));
      return { ...state, onlineUsers: newOnlineUsers };
    case 'REMOVE_ONLINE_USER':
      return {
        ...state,
        onlineUsers: state.onlineUsers.filter(user => user !== action.payload),
      };
    default:
      return state;
  }
}

export const ChatProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [state, dispatch] = useReducer(chatReducer, initialState);

  const value = {
    state,
    sessions: state.sessions,
    loading: state.loading,
  };

  return (
    <ChatContext.Provider value={value}>
      {children}
    </ChatContext.Provider>
  );
};

export const useChat = () => {
  const context = useContext(ChatContext);
  if (!context) {
    throw new Error('useChat must be used within a ChatProvider');
  }
  return context;
};
